module.exports = __webpack_public_path__ + "images/saaremaa/android-icon-48x48.png";